export class GenericList {
    DialogTitle: string;
    ColumnHeader: string;
    Items: GenericListItem[] = [];
    minRequiredSelected = 1;
    maxAllowedSelected = -1; // default of -1 allows ALL to be selected
    OKButtonLabel = 'OK';
}

export class GenericListItem {
    Id: string;
    TextField: string;
    ValueField: string;
    IsSelected: boolean;
}